import React, { memo } from "react";
import { Empty as AntEmpty } from "antd";
import type { EmptyProps as AntEmptyProps } from "antd";

const CustomEmpty: React.FC<AntEmptyProps> = (props) => <AntEmpty {...props} />;

export default memo(CustomEmpty);
